const ChairishContext = window.chairisher.context;

/**
 * @returns {string} URL FOr Apple's auth library.
 */
export function getAppleAuthJSUrl() {
    return ChairishContext.APPLE_AUTH_JS_URL;
}

/**
 * @returns {string} URL for loading the Certcapture's JS library.
 */
export function getCertcaptureJSUrl() {
    return ChairishContext.CERTCAPTURE_JS_URL;
}

/**
 * @returns {string} URL for loading Pinterest's JS library.
 */
export function getPinterestJSUrl() {
    return ChairishContext.PINTEREST_JS_URL;
}

/**
 * @returns {string} URL for loading the Recaptcha JS library.
 */
export function getRecaptchaJSUrl() {
    return ChairishContext.RECAPTCHA_JS_URL;
}

/**
 * @returns {string} URL for loading Stripes JS library.
 */
export function getStripeJSUrl() {
    return ChairishContext.STRIPE_JS_URL;
}
